import { Injectable } from '@angular/core';
import { StartupModel, ImageUploadUrl } from '../classes/model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

const httpOptions1 = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }), responseType: 'text' as 'json'
};

@Injectable()
export class RdsServerService {

  constructor(private http: HttpClient) { }

  _url = 'https://ebnro45a9h.execute-api.ap-south-1.amazonaws.com/v2';
  _LambdaUrl = 'https://52quz6nea1.execute-api.ap-south-1.amazonaws.com/alpha'

  //  ===============  POST STARTUP FORM  ====================
  postStartupForm(databody: StartupModel): Observable<StartupModel> {
    return this.http.post<StartupModel>(this._LambdaUrl + '/post-IMS_Applab-insert', databody, httpOptions1);
  }
  // ===============  SECTOR LOGO IMAGE UPLOAD  ====================
  getStartupLogoImageUrl(imageKey, extension): Observable<ImageUploadUrl> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get<ImageUploadUrl>(this._url + '/getStartupLogos' + '?ImageKey=' + imageKey + '&extension=' + extension, httpOptions);
  }
  // ===============  SECTOR PITCH IMAGE UPLOAD  ====================
  getStartupPitchImageUrl(imageKey, extension): Observable<ImageUploadUrl> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get<ImageUploadUrl>(this._url + '/getStartupPitch' + '?ImageKey=' + imageKey + '&extension=' + extension, httpOptions);
  }

  getUni(): Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get<any>(this._LambdaUrl+'/get-IMS_Uni-select', httpOptions);
    // return this.http.get<any>('http://localhost:3002'+'/get-IMS_Uni-select', httpOptions);
  }

  getInstitute(): Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get<any>(this._LambdaUrl+`/get-IMS_Institute-select`, httpOptions);
    // return this.http.get<any>(`http://localhost:3002/get-IMS_Institute-select?id=${id}`, httpOptions);
  }

  getProgram(): Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get<any>(this._LambdaUrl+`/get-IMS_Program-select`, httpOptions);
    // return this.http.get<any>(`http://localhost:3002/get-IMS_Program-select?id=${id}`, httpOptions);
  }

  postUni(databody: any): Observable<any> {
    return this.http.post<any>(this._LambdaUrl + '/post-IMS_Uni-insert', databody, httpOptions1);
  }

  postIns(databody: any): Observable<any> {
    return this.http.post<any>(this._LambdaUrl + '/post-IMS_Institute-insert', databody, httpOptions1);
  }

  postProg(databody: any): Observable<any> {
    return this.http.post<any>(this._LambdaUrl + '/post-IMS_Program-insert', databody, httpOptions1);
  }
}
